// extracted by css-extract-rspack-plugin
export default {"banner":"WlDkFG","stage-notifications":"UR2XPW","stageNotifications":"UR2XPW"};